var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZetLogo = function SvgZetLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 30,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#596379",
    clipPath: "url(#zetLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 0H42.662l4.155 9.268h9.567v20.836h9.131V9.268H75zM26.111 0H0v9.268h12.592L0 20.836v9.268h26.111v-9.268H13.52L26.111 9.268zM49.873 20.836h-13.31V19.24h12.57l-2.373-5.214-1.447-3.162h-8.75V9.268h7.941L40.346 0H28.201v30.104000000000003H54.11z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zetLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h75v30H0z"
  })))));
};
export default SvgZetLogo;